export const suspensionRulesFeatureFlag = 'isSuspensionRulesEnabled';
export const ssoManagementFeatureFlag = 'isSsoManagementEnabled';
